export class User {
    id!: string
    name!: string // Sign in name
    hrRef!: number
    displayName!: string
    emailAddress!: string
    rolesIds: string[] = []
    rightsFromRolesIds: string[] = []
    rightsFromRightsIds: string[] = []
    active!: boolean
    privileges: string[] = []
    roles!: string
    extraRightsNames!: string
    roleNames!: string
    isLessor!: boolean
    requireAuthenticatorMfa!: boolean
    twoFactorEnabled!: boolean
    isHighRisk!: boolean
    vendorId!: number
    image!: string
    imageUrl!: string

    // Additional properties from the Vista users
    positionCode!: string
    jobTitle!: string
    prgroup!: string
    earnCode!: string
    stdCraft!: string
    stdClass!: string
    prdept!: string

    showAlt!: boolean
}
